import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTeam } from 'app/frontend/base/config/context/team'
import { cn } from '@/lib/utils'

type Props = {
  event?: wowaudit.Event
  headerEvent: wowaudit.Event | wowaudit.EventReference
  className?: string
}

const EventDateNavigation = ({ event, headerEvent, className }: Props) => {
  const navigate = useNavigate()
  const { team } = useTeam()

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Button
        variant='outline'
        size='icon'
        className='shrink-0 h-7 w-7 min-h-7 min-w-7 max-sm:h-10 max-sm:w-10 max-sm:min-h-10 max-sm:min-w-10'
        disabled={!event?.siblings.previous}
        onClick={() => {
          if (!event?.siblings.previous) return
          navigate(`${team.path}/events/${event.siblings.previous}`)
        }}
      >
        <ChevronLeft className='h-4 w-4 max-sm:h-5 max-sm:w-5' />
      </Button>
      <span className='w-70 max-sm:w-auto max-sm:flex-1 text-center flex items-center justify-between flex-wrap gap-1'>
        <span>{dayjs(headerEvent.date).format('dddd, MMM D YYYY')}</span>
        <span className='text-xs text-foreground whitespace-nowrap'>
          {headerEvent.startTime} - {headerEvent.finishTime}
        </span>
      </span>
      <Button
        variant='outline'
        size='icon'
        className='shrink-0 h-7 w-7 min-h-7 min-w-7 max-sm:h-10 max-sm:w-10 max-sm:min-h-10 max-sm:min-w-10'
        disabled={!event?.siblings.next}
        onClick={() => {
          if (!event?.siblings.next) return
          navigate(`${team.path}/events/${event.siblings.next}`)
        }}
      >
        <ChevronRight className='h-4 w-4 max-sm:h-5 max-sm:w-5' />
      </Button>
    </div>
  )
}

export default EventDateNavigation
